import React, { type FunctionComponent, useCallback } from 'react'
import { Checkbox } from '@retailer-platform/shared-components'
import { useSelectionManager } from 'utils/selection-manager/SelectionManager'

interface Props {}

export const ProductsSearchTableSelectionHeader: FunctionComponent<Props> = () => {
  const { isGlobalSelection, globalSelect, selectedCount } = useSelectionManager()

  const onChange = useCallback(
    ({ currentTarget }: React.FormEvent<HTMLInputElement>) => globalSelect(currentTarget.checked),
    [globalSelect]
  )

  return (
    <div>
      <Checkbox
        data-testid="products-search-table-selection-header-checkbox"
        indeterminate={selectedCount && !isGlobalSelection}
        checked={isGlobalSelection}
        onChange={onChange}
      />
    </div>
  )
}
